<script>
import Vue from 'vue';
import {mapState, mapActions} from 'vuex';

export default Vue.extend({
    computed: {
        ...mapState({
            brands: state => state.contract.contractManagement.brands,
            selectedBrands: state => state.contract.contractManagement.form.extended.brands,
        }),
    },
    methods: {
        ...mapActions({
            addBrand: 'contract/addBrand',
            removeBrand: 'contract/removeBrand',
        }),
        isSelected (index) {
            return this.selectedBrands.includes(+index);
        },
        toggleBrand (index) {
            if (this.isSelected(index)) {
                this.removeBrand(index);
            } else {
                this.addBrand(index);
            }
        }
    },
});
</script>
<template>
    <div class="contract-management-edit-brands">
        <div class="contract-management-edit-brands__text">
            {{ $t('contractManagement.edit.form.brands.info') }}
        </div>
        <div v-for="(brand, index) in brands.brands"
             :key="'brands_' + index"
             :class="{'contract-management-edit-brands__open-select--selected': isSelected(index)}"
             class="contract-management-edit-brands__open-select"
             @click="toggleBrand(index)">
            {{ brand }}
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractManagementEditBrands/ContractManagementEditBrands.vue